<template>
  <div>
    <div class="bg-white shadow-sm navbar_border">
      <nav class="navbar navbar-expand-lg navbar-light navbarSpace">
        <div class="navbar-brand pointer py-0" @click.prevent="toLogoLink">
          <div class="PcDevice">
            <span class="WidthLongLogo">
              <img src="../assets/images/Exhibition_Logo.png" height="85px" alt="" />
            </span>
            <span class="WidthShortLogo">
              <img src="../assets/images/Exhibition_Logo.png" height="85px" alt="" />
            </span>
          </div>
          <div class="MbDevice">
            <img src="../assets/images/Exhibition_Logo.png" width="210px" height="70px" alt="" />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="nav-icon btn btn-outline-secondary rounded-circle mr-3 MbDevice" @click.prevent="openList">
            <i class="fas fa-user"></i>
          </div>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>

        <div class="collapse navbar-collapse text-center text-lg-left" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto navbarTopic">
            <li class="nav-item active">
              <div class="nav-link navbarGap " @click="goHome()">
                <span class="TopicStyle ml-2 pointer"> Home </span>
              </div>
            </li>

            <li class="nav-item  dropdown navbarGap ">
              <div
                class="nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="TopicStyle ml-2"> Exhibition </span>
              </div>
              <div class="dropdown-menu text-center text-lg-left" aria-labelledby="navbarDropdown">
                <router-link :to="`/Exhibitors/Page=${1}`">
                  <div class="dropdown-item " href="#">
                    Exhibitors
                  </div>
                </router-link>

                <router-link :to="`/Products/Page=${1}`">
                  <div class="dropdown-item " href="#">
                    Products
                  </div>
                </router-link>
                <router-link :to="`/PressReleases/Page=${1}`">
                  <div class="dropdown-item " href="#">
                    Press Releases
                  </div>
                </router-link>

                <router-link :to="`/Videos/Page=${1}`">
                  <div class="dropdown-item " href="#">
                    Videos
                  </div>
                </router-link>
              </div>
            </li>

            <!-- <li class="nav-item ">
              <div class="nav-link navbarGap ">
                <a href="https://www.chanchao.com.tw/IntelligentAsia/en/event.html" target="_blank">
                  <div class="TopicStyle pointer ml-2">
                    Events
                  </div>
                </a>
              </div>
            </li> -->
          </ul>

          <ul class="list-inline mb-0 mt-3 ml-2 MbDevice">
            <li class="list-inline-item">
              <a href="https://www.touchtaiwan.com/downloads/OnlineExpoVisitorManual.pdf" target="_blank">
                <div class="nav-icon btn btn-outline-secondary rounded-circle">
                  <i class="fas fa-book"></i>
                </div>
              </a>
            </li>
          </ul>

          <ul class="list-inline mb-0 mt-3 PcDevice">
            <li class="list-inline-item">
              <a href="https://www.touchtaiwan.com/downloads/OnlineExpoVisitorManual.pdf" target="_blank">
                <div
                  class="nav-icon btn btn-outline-secondary rounded-circle"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Visitor Manual"
                >
                  <i class="fas fa-book"></i>
                </div>
              </a>
            </li>

            <li class="list-inline-item unreadFrame" @click.prevent="updatavisible">
              <div
                class="nav-icon btn btn-outline-secondary rounded-circle"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Chat"
              >
                <i class="far fa-comment"></i>
              </div>
              <span class="mesbadge badge badge-pill" v-if="UnreadNum !== 0">
                {{ UnreadNum }}
              </span>
            </li>

            <li class="list-inline-item">
              <div
                class="nav-icon btn btn-outline-secondary rounded-circle"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Member Center"
                @click.prevent="openList"
              >
                <i class="fas fa-user"></i>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {}
    },

    methods: {
      openList() {
        if (this.ListStatus) {
          this.$store.dispatch('updateList', false)
        } else {
          this.$store.dispatch('updateList', true)
        }
      },

      updatavisible() {
        if (this.Roomvisible) {
          if (this.ShowRoom) {
            this.$bus.$emit('callClose')
          } else {
            this.$store.dispatch('ShowChatRoom', true)
          }
        } else {
          this.$store.dispatch('ShowChatRoom', true)
          this.$store.dispatch('Updatevisible', true)
        }
      },

      openFavoModal() {
        $('#FavoModal').modal('show')
      },

      goHome() {
        window.location.replace(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Home`)
      },

      toLogoLink() {
        window.location.replace(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Home`)
      },
    },

    created() {
      const vm = this
    },

    computed: {
      ...mapGetters(['ListStatus', 'UnreadNum', 'Roomvisible', 'ShowRoom']),
    },
  }
</script>

<style lang="scss" scoped>
  a:hover {
    text-decoration: none;
  }
  .data-box {
    position: relative;
    top: 10px;
    left: 1620px;
    width: 270px;
    height: 400px;
    z-index: 1000;
  }

  .mesbadge {
    position: absolute;
    top: 25px;
    right: 25px;
    font-size: 11px;
    background-color: #e0492e;
    color: #fff;
  }

  .nav_top {
    border-bottom: rgb(207, 207, 207) solid 1px;
  }

  .TopicStyle {
    color: #000000;
    font-size: 22px;
    transition: all 0.3s ease;

    &:hover {
      color: #1f59c2;
    }
  }

  .naver-title {
    font-size: 15px;
  }
  .nav-link {
    @media (max-width: 991px) {
      border-bottom: 1px solid rgba(65, 54, 54, 0.3);
      &:hover {
        background: rgb(238, 238, 237);
      }
      &.router-link-exact-active {
        font-weight: bold;
        font-size: 17px;
        background: rgb(230, 229, 228);
      }
    }
  }

  @media (max-width: 576px) {
    .navbarSpace {
      margin-right: 0rem;
      margin-left: 0rem;
      padding-top: 0rem;
      padding-bottom: 0rem;
    }

    .nav-link {
      position: relative;
      display: flex;
      justify-content: center;
    }

    .dropdown-toggle:after {
      margin-top: 14px;
    }

    .navbar-collapse {
      margin-bottom: 15px;
    }

    .dropdown-item {
      display: block;
      width: 100%;
      padding: 1rem 1rem;
      clear: both;
      color: #252525;
      text-align: inherit;
      white-space: nowrap;
      background-color: transparent;
      border: 0px;

      &:hover {
        background-color: #aea8ac3b;
      }
    }
  }

  @media (min-width: 576px) {
    .navbarSpace {
      margin-right: 3rem;
      margin-left: 3rem;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }

    .unreadFrame {
      position: relative;
    }
  }

  @media (min-width: 992px) {
    .navbarTopic {
      margin-right: 280px;
    }

    .navbarGap {
      margin-right: 70px;
    }
  }
</style>
